export class BusinessUnitType {
  id: number;
  name: string;
  active: boolean;
  isRootLevel: boolean;
  isLeafLevel: boolean;
  order: number;
}
